import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-zona-no-encontrada',
  templateUrl: './modal-zona-no-encontrada.component.html',
  styleUrls: ['./modal-zona-no-encontrada.component.scss']
})
export class ModalZonaNoEncontradaComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ModalZonaNoEncontradaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
    // console.log(this.data);
  }
  abrirConversacion() {
    let lug = this.data.lugar;
    // Construir el enlace de WhatsApp
    const enlaceWhatsApp = `https://wa.me/8117255009?text=Hola, estoy intentando registrar una reservación  de ${(lug.volteado ? 'Origen' : 'Destino')} en la dirección: ${(lug.volteado ? lug.destino : lug.destino).description} con código postal de (${this.data.cp}), gracias.`;
    // console.log(encodeURI(enlaceWhatsApp))
    // Abrir enlace en una nueva pestaña del navegador
    window.open(encodeURI(enlaceWhatsApp), '_blank');
  }
  cerrar(){
    this.dialogRef.close();
  }
}
